import React from "react";
import PT from "prop-types";
import ReactModal from "react-modal";
import { CloseIcon } from "../../atoms/close-icon";

import "./modal.m.css";

export class Modal extends React.Component {
  render() {
    return (
      <ReactModal
        className="nl-modal"
        overlayClassName="modal-backdrop"
        isOpen={true}
        onRequestClose={this.props.onBackdropClick}
      >
        <div className="modal-content">
          {this.props.children}
          {!this.props.hideCloseIcon && (
            <button styleName="close-button" onClick={this.props.onBackdropClick}>
              <CloseIcon />
            </button>
          )}
        </div>
      </ReactModal>
    );
  }
}

Modal.propTypes = {
  onBackdropClick: PT.func,
  children: PT.object,
  hideCloseIcon: PT.bool
};
